"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShareToken = void 0;
const PlatformToken_1 = require("./PlatformToken");
class ShareToken extends PlatformToken_1.PlatformToken {
    constructor(token) {
        super(ShareToken.TOKEN_TYPE, token);
    }
    get projectId() {
        return this.subject;
    }
}
exports.ShareToken = ShareToken;
ShareToken.TOKEN_TYPE = 'project';
//# sourceMappingURL=ShareToken.js.map